import React from 'react';
import classNames from 'classnames';

import Typography from 'components-new/typography/typography';
import Banner from 'components-new/banner/banner';

import type { PeriodJobAssignmentDetails } from 'state/__generated__/tadaahAPI';

import EmptyState from 'components-new/empty-state/empty-state';

import { createLocale } from 'locales';

import FreelancerOptions from './FreelancerOptions';

const localize = createLocale('organisationPeriodJobsLocales');

interface InvitedFreelancersTableTypes {
  assignmentDetails: PeriodJobAssignmentDetails;
}

const InvitedFreelancersTable: React.FC<InvitedFreelancersTableTypes> = (
  props,
) => {
  const { assignmentDetails } = props;

  const columns = [
    { id: 1, name: localize('invitedFreelancers') },
    { id: 2, name: localize('period') },
    { id: 3, name: localize('accepted') },
    { id: 4, name: localize('pending') },
    { id: 5, name: localize('refused') },
    { id: 6, name: localize('total') },
    { id: 7, name: '' },
  ];

  if (!assignmentDetails) return <></>;

  return (
    <div className="border rounded-xl border-[#E7E6E8] shadow bg-white w-full md:mr-0 overflow-x-scroll">
      <table className="w-full table-auto overflow-x-scroll min-w-[1024px]">
        <thead className="text-gray-700 h-12 uppercase text-left bg-gray-5">
          {columns.map((col) => (
            <Typography
              key={col.id}
              as="th"
              variant="body-medium-bold"
              className="text-gray-400 pl-3 rounded-tl-md border-b border-b-[#E7E6E8]"
            >
              {col.name}
            </Typography>
          ))}
        </thead>
        <tbody className="rounded-b-md w-full">
          {!assignmentDetails.invited_freelancers.length && (
            <tr className="table-row">
              <td colSpan={columns.length} className="table-cell">
                <div className="flex items-center justify-center mx-5 py-3">
                  <EmptyState errorText="No Invited freelancers are available yet" />
                </div>
              </td>
            </tr>
          )}
          {!!assignmentDetails.invited_freelancers &&
            assignmentDetails.invited_freelancers.map((freelancer, index) => {
              const tdClassNames = classNames(
                index !== assignmentDetails.invited_freelancers.length - 1 &&
                  'border-b border-b-[#E7E6E8]',
                'text-gray-700',
              );
              return (
                <tr
                  key={`${freelancer.freelancer?.id} - ${freelancer.from_date}`}
                  className="bg-white h-12"
                >
                  <Typography
                    as="td"
                    variant="body-large"
                    className={classNames(
                      tdClassNames,
                      freelancer.freelancer?.first_name && 'pl-3',
                    )}
                  >
                    {freelancer.freelancer?.first_name || (
                      <Banner
                        title={localize('convertedToUrgent')}
                        variant="warning"
                        className="w-fit ml-3"
                      />
                    )}
                  </Typography>

                  <Typography
                    as="td"
                    variant="body-large"
                    className={tdClassNames}
                  >
                    {`${freelancer.from_date} - ${freelancer.to_date} `}
                  </Typography>
                  <Typography
                    as="td"
                    variant="body-large"
                    className={tdClassNames}
                  >
                    {freelancer.accepted}
                  </Typography>
                  <Typography
                    as="td"
                    variant="body-large"
                    className={tdClassNames}
                  >
                    {freelancer.pending}
                  </Typography>
                  <Typography
                    as="td"
                    variant="body-large"
                    className={tdClassNames}
                  >
                    {freelancer.refused}
                  </Typography>
                  <Typography
                    as="td"
                    variant="body-large"
                    className={tdClassNames}
                  >
                    {freelancer.sub_total}
                  </Typography>
                  <td className={tdClassNames}>
                    <FreelancerOptions freelancer={freelancer} />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default InvitedFreelancersTable;
